import React from 'react';
import { Col, Descriptions } from 'antd';
import { Inference } from '../../types';
import { useTranslation } from 'react-i18next';

type Props = {
  inferenceFile: Inference | null;
  pubdemo?: boolean;
};

export const ResultProperties = ({ inferenceFile, pubdemo }: Props) => {
  const { t } = useTranslation();
  const properties = inferenceFile?.inferenceResult?.result?.properties;

  return (
    <Col className="mb-1 px-4">
      {properties ? (
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('label.currency')}>
            {properties.currency === 'unknown' ? t('general.unknown') : properties.currency}
          </Descriptions.Item>
          <Descriptions.Item label={t('label.documentType')}>
            {t(`label.doctype-${properties.doctype}`) || t('general.unknown')}
          </Descriptions.Item>
          {properties.payment_information && !pubdemo ? (
            <>
              <Descriptions.Item label={t('label.paymentStatus')}>
                {properties.payment_information.already_paid ? t('label.paid') : t('label.not-paid')}
              </Descriptions.Item>
              {properties.payment_information.already_paid ? (
                <Descriptions.Item label={t('label.paymentMethod')}>
                  {properties.payment_information.payment_method || t('general.unknown')}
                </Descriptions.Item>
              ) : null}
            </>
          ) : null}
          {properties.vat_exemption_information && !pubdemo ? (
            <>
              <Descriptions.Item label={t('label.exemptedFromVat')}>
                {properties.vat_exemption_information.exempted_from_vat ? t('general.yes') : t('general.no')}
              </Descriptions.Item>
              {properties.vat_exemption_information.exempted_from_vat && (
                <Descriptions.Item label={t('label.reasonForExemption')}>
                  {properties.vat_exemption_information.reason || t('general.unknown')}
                </Descriptions.Item>
              )}
            </>
          ) : null}
        </Descriptions>
      ) : null}
    </Col>
  );
};
